import { render, staticRenderFns } from "./IncDec.vue?vue&type=template&id=5f92b901&scoped=true&"
import script from "./IncDec.vue?vue&type=script&lang=js&"
export * from "./IncDec.vue?vue&type=script&lang=js&"
import style0 from "./IncDec.vue?vue&type=style&index=0&id=5f92b901&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f92b901",
  null
  
)

export default component.exports